<template>
  <div id="app" class="chat-container">
   <router-view></router-view>
  </div>
</template>

<script>

export default {
  components: {
 
  },
  computed: {
    isLoginPage() {
      // 直接检查URL路径，而不是依赖Vue Router，避免路由未解析时的闪现
      const currentPath = window.location.pathname;
      return currentPath === '/login';
    }
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
#app {

  // 登录页面的特殊样式
  &.login-page {
    border-radius: 0;
    margin: 0;
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    display: block;
  }

  // 其他页面的默认样式
  &:not(.login-page) {
    display: flex;

    margin: 20px auto;
    width: 860px;
    height: 610px;
    background-color: #fff;
    z-index: 10;
    position: relative;

    .sidebar {
      width: 60px;
      height: 610px;
      background: #2b2c2f;
      position: relative;
      z-index: 20;
    }

    .main {
      flex: 1;
      height: 610px;
      background: #f2f2f2;
      position: relative;
      z-index: 10;
    }
  }
}
</style>
